<template>
  <div class="noneData">
    <img
      class="noneIcon"
      :src="
        $utils.getPng(
          $store.state.theme == 'light'
            ? 'icon-gfans-none'
            : 'icon-gfans-none-dark'
        )
      "
    />
    <div class="font1">抱歉，未找到该{{ title }}</div>
    <div class="font2">将在 {{ time }} 秒后自动返回 订阅</div>
    <div class="prohibitbtn primaryBtn" @click="goDyh">返回订阅</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      time: 5,
      timerA: null,
    }
  },
  mounted() {
    this.timerA = setInterval(() => {
      this.timeFn()
    }, 1000)
  },
  props: {
    title: {
      type: String,
      default: '订阅号',
    },
  },
  methods: {
    goDyh() {
      if (this.$store.state.isLogin == 0) {
        this.$router.replace({ path: '/discover' })
      } else {
        this.$router.replace({ path: '/subscribe' })
      }
    },
    timeFn() {
      this.time = this.time - 1
      if (this.time == 0) {
        this.time = 0
        this.goDyh()
        clearInterval(this.timerA)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.noneData {
  margin-top: 72px !important;
}
.prohibit-img {
  width: 338px;
  height: 166px;
  margin-bottom: 20px;
}

.prohibit-txt {
  height: 20px;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  margin-bottom: 16px;
  @include useTheme {
    color: getVar('text-color1-2c2c2c');
  }
}
.prohibit-txt2 {
  height: 18px;
  font-size: 18px;
  color: #8a8b92;
  line-height: 18px;
}
.prohibitbtn {
  width: 128px;
  height: 40px;
  border-radius: 20px;
  font-weight: 500;
  font-size: 16px;
  color: #ffffff;
  line-height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 24px;
  cursor: pointer;
}
</style>
